( function ( _s ) {
	_s.fn.frFooter = function () {
		return this.el.forEach( footer => {
			const _footer = _s( footer );
			const _menuWrapper = _footer.find( '.menu-items-wrap > .footer-menu-container' );
			const _topMenuItems = _menuWrapper.find( '> .menu-item' );
			const _submenus = _topMenuItems.find( '> .sub-menu' );
			let breakpoint = window.currentBreakpoint();

			const addSubmenuAttributes = () => {
				let index = 0;
				_submenus.each( submenu => {
					const _submenu = _s( submenu );

					_submenu.attr( 'id', `footer-submenu-${ index }` );
					_submenu
						.closest( '.menu-item-has-children' )
						.find( '.expand-submenu' )
						.attr( 'aria-controls', `footer-submenu-${ index }` )
						.attr( 'data-bs-target', `#footer-submenu-${ index }` )
						.attr( 'data-bs-toggle', 'collapse' );

					index++;
				} );
			};

			const menuOverflow = () => {
				return _menuWrapper.el[ 0 ].scrollWidth > _menuWrapper.el[ 0 ].clientWidth;
			};

			const getDefaultMenuHeight = () => {
				let heightOfTallerMenuColumn = 0;

				_topMenuItems.each( item => {
					const itemHeight = _s( item ).outerHeight();
					if ( itemHeight > heightOfTallerMenuColumn )
						heightOfTallerMenuColumn = itemHeight;
				} );

				return heightOfTallerMenuColumn;
			};

			const setDefaultMenuHeight = () => {
				const height = getDefaultMenuHeight();

				window.setRootProperty( '--footer-menu-height', height + 'px' );
			};

			const calculateMenuHeight = ( height = getDefaultMenuHeight() ) => {
				height += 10;
				window.setRootProperty( '--footer-menu-height', height + 'px' );

				if ( menuOverflow() ) {
					setTimeout( () => {
						calculateMenuHeight( height );
					}, 1 );
				}
			};

			const setMenuHeight = ( calculate = true ) => {
				if ( [ 'xl', 'xxl' ].includes( window.currentBreakpoint() ) ) {
					setDefaultMenuHeight();

					if ( calculate ) calculateMenuHeight();
				}
			};

			const initMasonry = () => {
				window.FlexMasonry.init( _menuWrapper.el, {
					responsive: false,
					numCols: 4,
				} );
			};

			addSubmenuAttributes();

			initMasonry();

			setMenuHeight();

			_s( window ).on(
				'resize',
				window.debounce( () => {
					if ( breakpoint !== window.currentBreakpoint() ) {
						breakpoint = window.currentBreakpoint();
						setMenuHeight();
					}
				}, 500 )
			);
		} );
	};

	_s( document ).ready( () => {
		window
			.fetchInject( [
				'https://unpkg.com/flexmasonry/dist/flexmasonry.css',
				'https://unpkg.com/flexmasonry/dist/flexmasonry.js',
			] )
			.then( () => {
				_s( '#app > footer' ).frFooter();
			} );
	} );
} )( window._s );
